import { useTheme } from 'styled-components'

import {
  BodyTypeTileContainer,
  BodyTypeTileImage,
  BodyTypeTileImageContainer,
} from '@/components/brp/styled'
import { LinkCustom } from '@/components/shared/link-custom/LinkCustom'
import { BodyText } from '@/ui/atoms/body-text'
import { Spacing } from '@/ui/atoms/spacing'

export type BodyTypeTileProps = {
  /**
   * Display label for the body type
   */
  label: string
  /**
   * Image source
   */
  imageSrc: string
  /**
   * Navigation URL
   */
  url: string
  /**
   * Function triggered on tile click
   */
  onClick: (tileLabel: string) => void
}

export const BodyTypeTile = ({ label, imageSrc, url, onClick }: BodyTypeTileProps) => {
  const { spacing } = useTheme()

  const handleClick = () => {
    onClick(label)
  }

  return (
    <LinkCustom href={url} noStyle style={{ textDecoration: 'none' }} onClick={handleClick}>
      <BodyTypeTileContainer>
        <BodyTypeTileImageContainer>
          <BodyTypeTileImage src={imageSrc} alt={label} />
        </BodyTypeTileImageContainer>
        <Spacing mTop={spacing.default}>
          <BodyText textAlign="center">{label}</BodyText>
        </Spacing>
      </BodyTypeTileContainer>
    </LinkCustom>
  )
}
